// Create a set to remember fonts already requested.
const requestedGoogleFonts = new Set();



// Create a set to remember fonts that are ready to use.
const loadedGoogleFonts = new Set();



// Build a lighter Google Fonts URL for one font family.
const BuildGoogleFontUrl = (fontFamily) => {

    if (!fontFamily) return null;

    // Convert the font family into a Google Fonts URL-safe format.
    const encodedFontFamily = String(fontFamily || "").trim().replace(/\s+/g, "+");

    // Return only weight 400 to avoid downloading lots of unnecessary font files.
    return `https://fonts.googleapis.com/css2?family=${encodedFontFamily}:wght@400&display=swap`;

};



// Check if the browser says this font is ready.
export const IsGoogleFontLoaded = (fontFamily) => {

    // Normalise the font name.
    const normalizedFontFamily = String(fontFamily || "").trim();

    // Return false if there is no font.
    if (!normalizedFontFamily) {

        // Exit early.
        return false;

    }

    // Ask the browser whether the font can currently render.
    return document.fonts.check(`16px "${normalizedFontFamily}"`);

};



// Load one Google Font.
export const LoadGoogleFont = (fontFamily) => {

    // Normalise the font name.
    const normalizedFontFamily = String(fontFamily || "").trim();

    // Do nothing if there is no font.
    if (!normalizedFontFamily) {

        // Exit early.
        return;

    }


    // Do nothing if this font has already loaded through this manager.
    if (loadedGoogleFonts.has(normalizedFontFamily)) {

        // Exit early.
        return;

    }

    // Do nothing if this font has already been requested.
    if (requestedGoogleFonts.has(normalizedFontFamily)) {

        // Exit early.
        return;

    }

    // Mark this font as requested.
    requestedGoogleFonts.add(normalizedFontFamily);

    // Create a stylesheet link.
    const linkElement = document.createElement("link");

    // Set the link as a stylesheet.
    linkElement.rel = "stylesheet";

    // Set the Google Fonts URL.
    linkElement.href = BuildGoogleFontUrl(normalizedFontFamily);

    if (!linkElement.href) {
        return;
    }

    // Add a devtools marker.
    linkElement.dataset.googleFontFamily = normalizedFontFamily;

    // When the stylesheet loads, wait for the actual font to become ready.
    linkElement.onload = () => {

        // Ask the browser to finish loading this font.
        document.fonts.load(`16px "${normalizedFontFamily}"`).then(() => {

            // Mark this font as loaded.
            loadedGoogleFonts.add(normalizedFontFamily);

        });

    };

    // Add the stylesheet to the page.
    document.head.appendChild(linkElement);

};



// Load several fonts slowly without blocking the UI.
export const LoadGoogleFontsIdle = (fontFamilies = []) => {

    // Create the queue of fonts to load.
    const fontQueue = [...fontFamilies];

    // Create the load-next function.
    const loadNextFont = () => {

        // Get the next font.
        const nextFont = fontQueue.shift();

        // Stop if there are no fonts left.
        if (!nextFont) {

            // Exit early.
            return;

        }

        // Load this font.
        LoadGoogleFont(nextFont);

        // Schedule the next font gently.
        window.setTimeout(loadNextFont, 120);

    };

    // Start loading when the browser has spare time if supported.
    if ("requestIdleCallback" in window) {

        // Start during idle time.
        window.requestIdleCallback(loadNextFont);

        // Exit early.
        return;

    }

    // Fallback for browsers without requestIdleCallback.
    window.setTimeout(loadNextFont, 120);

};



// Load fonts needed by the main app shell.
export const LoadDefaultFonts = () => {

    // Load the main body font.
    LoadGoogleFont("Montserrat");

};